import { createSlice } from '@reduxjs/toolkit';

import getAccounts from './AccountsActions';

import { ACCOUNTS } from 'features/home/core/ReduxNames';

const initialState = {
  accounts: null,
  isAccountsFetching: false,
};

const accountsSlice = createSlice({
  name: ACCOUNTS,
  initialState,
  reducers: {
    setAccountsFetch: (state, action) => {
      state.isAccountsFetching = action.payload;
    },
  },
  extraReducers: {
    [getAccounts.pending.type]: (state) => {
      Object.assign(state, initialState);
    },
    [getAccounts.fulfilled.type]: (state, action) => {
      state.accounts = action.payload.data;
    },
  },
});

export const { setAccountsFetch } = accountsSlice.actions;
export default accountsSlice.reducer;
